loggedInBootstrapPhaseInit